const isChartDefinition = (
  card: CanvasCard.Card,
): card is CanvasCard.ChartDefinitionCard =>
  card.content.type === 'Chart Definition';

export default isChartDefinition;
